import { render, staticRenderFns } from "./radios.vue?vue&type=template&id=a9ef8e46&scoped=true&"
import script from "./radios.vue?vue&type=script&lang=js&"
export * from "./radios.vue?vue&type=script&lang=js&"
import style0 from "./radios.vue?vue&type=style&index=0&id=a9ef8e46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9ef8e46",
  null
  
)

export default component.exports